import GalleryData from "../../data/GalleryData";
import GalleryComponent from "../../components/GalleryComponent/GalleryComponent";
import Head from "next/head";
import WithoutImageBanner from "../../components/Reusable/Banner/WithoutImageBanner";

const Gallery = () => {
    return (
        <>
            <Head>
                <title>Gallery | Adventure Resorts</title>
                {/* <meta name="description" content="We have more than five years of expertise in the field of helicopter safari, during which time we have provided tourists with genuine and exciting adventures." /> */}
                <link rel="icon" href="/favicon.png" />
                <link rel="canonical" href="https://www.adventureresortkufri.com/gallery" />
            </Head>
            <WithoutImageBanner />

            <section className="common_padding pb-0" id='firstsec'>
                <div className='container'>
                    <div className='row justify-content-center'>
                        <div className='col-md-8 common_title text-center'>
                            <h2>Gallery</h2>
                            <p>Adventure Resorts Shimla offers the ultimate student destination, boasting thrilling activities and attractions amidst Himachal Pradesh's scenic landscapes.</p>
                        </div>

                    </div>
                    <div className='text-center'>
                        <GalleryComponent GalleryData={GalleryData} />
                    </div>
                </div>
            </section>

        </>
    );
}
export default Gallery;